import { camelToDash } from './basler-components.es869.js';

const optimizedAppearDataId = "framerAppearId";
const optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);

export { optimizedAppearDataAttribute, optimizedAppearDataId };
